// ใช้ดึงข้อมูลทั้งหมดสำหรับ dropdown (backend default limit = 10)
export const LIMIT_ALL = 10000

// จำนวนรายการต่อการค้นหาใน dropdown แบบ search ผ่าน API
export const LIMIT_SEARCH = 20
